import React from "react";
import { colors } from "../../../../../../themes/Colors";

const TaskHeader = () => {
  return (
    <div
      style={{
        width: "100%",
        height: 50,
        backgroundColor: colors.greenLight,
        display: "flex",
        alignItems: "center",
        fontWeight: "bold",
        fontSize: 12,
        color: colors.white,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "left",
          flex: 0.05,
        }}
      ></div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "left",
          flex: 0.1,
        }}
      >
        TASK TYPE
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "left",
          flex: 0.2,
        }}
      >
        TITLE
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "left",
          flex: 0.15,
        }}
      >
        AGENCY
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "left",
          flex: 0.25,
          // borderStyle: "solid",
        }}
      >
        USER
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "left",
          flex: 0.1,
          // borderStyle: "solid",
          textAlign: "left",
        }}
      >
        <div style={{ width: "100%" }}>STATUS</div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "left",
          flex: 0.15,
          // borderStyle: "solid",
        }}
      >
        ACTION
      </div>
    </div>
  );
};

export default TaskHeader;
